import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  ADD_GLOBAL_POPUP_WRAPPER,
  CLEAR_GLOBAL_POPUP_WRAPPER, CLOSE_ALL_POPUP_WRAPPER,
} from './actions';
import { INFORMATION_SCREEN_WRAPPER } from '../../configs/moduleNames';

const initialState = {
  window: null,
  window2: null,
  id: null,
  id2: null,
};

const reducer = handleActions({
  [INFORMATION_SCREEN_WRAPPER + ADD_GLOBAL_POPUP_WRAPPER]: (state, action) => {
    const {
      payload: {
        window = null, window2 = null, id = null, id2 = null,
      },
    } = action;
    const {
      window: currentWindow = null, window2: currentWindow2 = null, id: currentId = null, id2: currentId2 = null,
    } = state;

    const nextWindow2 = currentWindow && currentWindow2 ? window2 : currentWindow2 || window2;

    const nextId2 = currentId && currentId2 ? id2 : currentId2 || id2;

    return {
      ...state,
      isShow: true,
      window: currentWindow || window,
      window2: nextWindow2,
      id: currentId || id,
      id2: nextId2,
    };
  },
  [INFORMATION_SCREEN_WRAPPER + CLEAR_GLOBAL_POPUP_WRAPPER]: (state, action) => {
    const { payload: { key = null } } = action;
    const { window = '', window2 = '' } = state;

    if (window === key || !key) {
      return {
        ...state, window: null, window2: null, isShow: false, id: null, id2: null,
      };
    }

    if (window2 === key) {
      return { ...state, window2: null, id2: null };
    }

    return state;
  },
  [INFORMATION_SCREEN_WRAPPER + CLOSE_ALL_POPUP_WRAPPER]: (state, action) => ({
    ...state, window: null, window2: null, isShow: false, id: null, id2: null,
  }),
}, initialState);

export default reducer;

export const getGlobalPopUpWrapper = createSelector(
  [state => state[INFORMATION_SCREEN_WRAPPER]],
  state => {
    const {
      content = [],
      isShow = false,
      window = null,
      window2 = null,
      id = null,
      id2 = null,
    } = state;
    return {
      content,
      isShow,
      window,
      window2,
      id,
      id2,
    };
  },
);
